import React, {FunctionComponent, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {renderPanelSidebarMenuItems} from "../index";
import {SidebarContent} from "../../../layout";
import useAccessLevels from "../../../../hooks/use-access-levels";
import usePurchasingKeyController from "../../../../hooks/use-purchasing-key";
import {createGlobalScope} from "../../../panel-command-search";
import {panelEntriesToSidebarItems, createOperatorPanelEntries} from "../../../../panel-entries";
import {ContactUsUnreadCountProvider} from "../../../../views/panel/operator/support/contact-us-messages/contact-us-unread-count-context";


const PanelSidebarDefaultContent: FunctionComponent = () => {
    const operatorAccessLevels = useAccessLevels();
    const {purchasingKeyForPlanning} = usePurchasingKeyController({load: true});
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.sidebar.default'});
    const {t: tCmd} = useTranslation("components", {keyPrefix: 'panel-sections.command-search.pages'});

    const entries = useMemo(
        () => createOperatorPanelEntries({t, tCmd, packages: operatorAccessLevels.packages, purchasingKeyForPlanning}),
        [t, tCmd, operatorAccessLevels.packages, purchasingKeyForPlanning],
    );

    const scope = useMemo(() => createGlobalScope('main'), []);

    const canAccess = useMemo(() => (accessKey: string) => {
        const [pkg, flag] = accessKey.split('.');
        return Boolean((operatorAccessLevels.packages as unknown as Record<string, Record<string, unknown>>)?.[pkg]?.[flag]);
    }, [operatorAccessLevels.packages]);

    const items = useMemo(
        () => panelEntriesToSidebarItems(entries, scope, {canAccess, panelEntries: entries}),
        [entries, scope, canAccess],
    );

    const content = useMemo(() => renderPanelSidebarMenuItems(items), [items]);

    return (
        <ContactUsUnreadCountProvider>
            <SidebarContent>
                {content}
            </SidebarContent>
        </ContactUsUnreadCountProvider>
    );
}


export default PanelSidebarDefaultContent;
